import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Container} from 'react-bootstrap'
import MenuAdmin from '../components/menus/MenuAdmin'
import Dashboard from '../pages/admin/Dashboard'
import Users from '../pages/admin/users/Users'
import UsersEdit from '../pages/admin/users/UsersEdit'
import UserOrders from '../pages/admin/users/UserOrders'
import Restaurants from '../pages/admin/restaurants/Restaurants'
import RestaurantsEdit from '../pages/admin/restaurants/RestaurantsEdit'
import MenusDashboard from '../pages/admin/menus/Dashboard'
import Products from '../pages/admin/menus/products/Products'
import Assignmenus from '../pages/admin/menus/menus/Assignmenus'
import Assignmenuscalendar from '../pages/admin/menus/menus/Assignmenuscalendar'
import Menus from '../pages/admin/menus/menus/Menus'
import MenusEdit from '../pages/admin/menus/menus/MenusEdit'
import OrdersDashboard from '../pages/admin/orders/Dashboard'
import Ordersfordelivery from '../pages/admin/orders/Ordersfordelivery'
import Ordersdelivered from '../pages/admin/orders/Ordersdelivered'
import Logs from '../pages/admin/Logs'
import Orderspendingpay from '../pages/admin/orders/Orderspendingpay'

export default function AdminRouter () {
	return (
		<Container className='contenido admin'>
			<MenuAdmin/>
			<Routes>
				<Route path="/dashboard" element={<Dashboard/>}/>
				<Route path="/users" element={<Users/>}/>
				<Route path="/users/:id" element={<UsersEdit/>}/>
				<Route path="/userorders/:id" element={<UserOrders/>}/>
				<Route path="/restaurants" element={<Restaurants/>}/>
				<Route path="/restaurants/:id" element={<RestaurantsEdit/>}/>
				<Route path="/menusdashboard" element={<MenusDashboard/>}/>
				<Route path="/assignmenus" element={<Assignmenus/>}/>
				<Route path="/assignmenus/:id" element={<Assignmenuscalendar/>}/>
				<Route path="/products" element={<Products/>}/>
				<Route path="/menus" element={<Menus/>}/>
				<Route path="/menus/:id" element={<MenusEdit/>}/>
				<Route path="/ordersdashboard" element={<OrdersDashboard/>}/>
				<Route path="/ordersfordelivery" element={<Ordersfordelivery/>}/>
				<Route path="/orderspendingpay" element={<Orderspendingpay/>}/>
				<Route path="/ordersdelivered" element={<Ordersdelivered/>}/>
				<Route path="/logs" element={<Logs/>}/>
				<Route path="*" element={<NotFoundPage />}/>
			</Routes>
		</Container>
	)
}